import { render, staticRenderFns } from "./approvalCenter.vue?vue&type=template&id=32a2b946&scoped=true&"
import script from "./approvalCenter.vue?vue&type=script&lang=js&"
export * from "./approvalCenter.vue?vue&type=script&lang=js&"
import style0 from "./approvalCenter.vue?vue&type=style&index=0&id=32a2b946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2b946",
  null
  
)

export default component.exports